export default __webpack_public_path__ + "static/media/close.190b7147.svg";